import type { ReactNode } from "react";
import { classNames } from "../styles/classNames";

interface EmptyStateProps {
  /** `small` in side panels and dense lists. */
  size?: "small" | "regular";
  /** A next step, such as a button that adds the first one. */
  action?: ReactNode;
  className?: string;
  /** What is not there yet, and if it helps, how it comes. */
  children: ReactNode;
}

/** An empty list or pane, said plainly, with what to do next where there is something. */
export default function EmptyState({ size = "regular", action, className, children }: EmptyStateProps) {
  const text = <p className={classNames("app-text-muted", size === "small" ? "text-xs" : "text-sm", action === undefined && className)}>{children}</p>;
  return action === undefined ? text : (
    <div className={classNames("flex flex-wrap items-center gap-2", className)}>
      {text}
      {action}
    </div>
  );
}
